import { render, staticRenderFns } from "./noteDetail.vue?vue&type=template&id=15a8a3d2&scoped=true"
import script from "./noteDetail.vue?vue&type=script&lang=js"
export * from "./noteDetail.vue?vue&type=script&lang=js"
import style0 from "./noteDetail.vue?vue&type=style&index=0&id=15a8a3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a8a3d2",
  null
  
)

export default component.exports